import React, { useState } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { saveSentimentDocument, sentimentUpdateContent } from 'redux/actions/SentimentAction';
import {
  Insight, AddNewInsight, OpinionFeature
} from 'components';
import {
  MozartIcon, MozartPopover, MozartModal
} from '@pgforsta/mozart_ui';
import './Sentence.scss';

function Sentence(props) {
  const {
    sentenceIndex, sentence, category, fullReview,
    subCategory, contentId, documentReducer,
    getNewSentenceSentimentObj, subCategories
  } = props;
  const {
    providerLocation, surveyQuestion
  } = documentReducer.documentData;
  const newSentimentItems = [];
  let sentenceCustomText = '';

  let [currentSentence, setCurrentSentence] = '';

  const buildSentenceItem = () => {
    const sentenceItem = JSON.parse(JSON.stringify(sentence));
    sentenceItem.insights.forEach((insight) => {
      insight.subCategory = subCategories;
      insight.previousSentiment = insight.sentiment;
      insight.previousCategory = insight.categoryId;
      insight.previousCategoryName = insight.category;
      insight.previousSubCategory = insight.subCategory;
      insight.previousTheme = insight.theme;
      insight.previousThemeId = insight.themeId;
    });
    return sentenceItem;
  };

  let [currentSentenceInsight, setCurrentSentenceInsight] = '';
  [currentSentenceInsight, setCurrentSentenceInsight] = useState('');
  const [opinionModal, setOpinionModal] = useState(false);
  const [pickedOpinion, setPickedOpinion] = useState([]);
  const [pickedFeature, setPickedFeature] = useState([]);
  const [newSentiment, setNewSentiment] = useState([]);
  const [currentInsightIndex, setCurrentInsightIndex] = useState(null);
  [currentSentence, setCurrentSentence] = useState(buildSentenceItem);
  const [openEditor, setOpenEditor] = useState(false);
  const opinion = '';
  const feature = '';
  const entity = '';
  let enableClass = 'add-button-disable';
  let passDataStatus = false;
  const warningMessage = '*Max 250 characters';
  if (newSentiment && newSentiment.insight && ((newSentiment.insight.opinion && newSentiment.insight.opinion.length > 250) || (newSentiment.insight.feature && newSentiment.insight.feature.length > 250) || (newSentiment.insight.featureAltKeyword && newSentiment.insight.featureAltKeyword.length > 250))) {
    enableClass = 'add-button-disable';
  } else if (newSentiment && newSentiment.insight && newSentiment.insight.opinion && (newSentiment.insight.feature || newSentiment.insight.featureAltKeyword)) {
    enableClass = 'add-button-enable';
    passDataStatus = true;
  }

  const sentenceInfoBlock = (
    <MozartPopover
      icon={<a style={{ cursor: 'pointer', color: '#17A589', fontSize: '12px' }} href>view more</a>}
      style={{
        minWidth: '600px', padding: '20px 10px', maxHeight: 'auto', zIndex: 100000, position: 'absolute', border: '1px solid #D3CFF8', boxShadow: 'unset'
      }}
      node={(
        <div>
          {currentSentence.text ? currentSentence.text.replace(/[[\]{}(//)*+@\\^$|#<>]/ig, '').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '') : ''}
        </div>
      )}
    />
  );
  sentenceCustomText = currentSentence.text && currentSentence.text.length >= 250 ?
    (
      <div>
        <div>
          {currentSentence.text.substring(0, 250).replace(/[[\]{}(//)*+@\\^$|#<>]/ig, '').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '') + '...'}
          <div>{sentenceInfoBlock}</div>
        </div>
      </div>
    ) : currentSentence.text.replace(/[[\]{}(//)*+@\\^$|#<>]/ig, '').replace(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])/g, '');

  const getInsights = (insights) => {
    const insightsDiv = [];
    if (insights && insights.length > 0) {
      insights.forEach((insight, index) => {
        insightsDiv.push(
          <Insight
            key={'insight-' + index}
            category={category}
            index={index}
            insight={insight}
            sentencesId={currentSentence.id}
            openEditor={openEditor}
            handleCategoryChange={handleCategoryChange}
            handleCategoryThemeChange={handleCategoryThemeChange}
            handleSentiment={handleSentiment}
            handleSaveSentiment={handleSaveSentiment}
            handleResetSentiment={handleResetSentiment}
            handleDeleteSentimentModal={handleDeleteSentimentModal}
            handleDeleteSentimentById={handleDeleteSentimentById}
            handleOpinionModal={handleOpinionModal}
          />
        );
      });
    }
    return (
      <div>
        <div>{insightsDiv}</div>
        <div>{newSentimentItems}</div>
      </div>
    );
  };

  // slice() keeps the holes that delete leaves behind, so forEach still skips removed insights.
  const updateInsights = (updater) => {
    setCurrentSentence((previous) => {
      const insights = previous.insights.slice();
      const changed = updater(insights, previous) || {};
      return { ...previous, ...changed, insights };
    });
  };

  const patchInsight = (index, patch) => {
    updateInsights((insights) => {
      if (!insights[index]) {
        return null;
      }
      insights[index] = { ...insights[index], ...patch };
      return null;
    });
  };

  const handleSentiment = (insightIndexId, sentenceId, value) => {
    patchInsight(insightIndexId, { sentiment: value });
  };

  const handleCategoryChange = (data, insightIndexId) => {
    const patch = { categoryId: data };
    category.children.forEach((categoryItem) => {
      if (categoryItem && categoryItem.id === data) {
        patch.subCategory = categoryItem.children && categoryItem.children.length > 0 ? categoryItem.children : [categoryItem];
        patch.category = categoryItem.name;
        patch.categoryName = categoryItem.name;
        patch.theme = null;
        patch.themeName = null;
        patch.themeId = null;
      }
    });
    patchInsight(insightIndexId, patch);
  };

  const handleCategoryThemeChange = (data, insightIndexId) => {
    const patch = { themeId: data };
    subCategory.forEach((categoryItem) => {
      if (categoryItem && categoryItem.id === data) {
        patch.themeName = categoryItem.name;
        patch.theme = categoryItem.name;
      }
    });
    patchInsight(insightIndexId, patch);
  };

  const handleSaveSentiment = (insightIndexId, sentencesId, insightId) => {
    const updateStatus = (insightId && insightId > 0) ? insightId : 0;
    if (sentencesId && updateStatus === 0) {
      const insightData = currentSentence.insights[insightIndexId];
      const subCategoryObj = currentSentence.insights[insightIndexId].subCategory;
      if (!documentReducer.loading) {
        props.saveSentimentDocument(contentId, sentencesId, insightData).then((response) => {
          if (response && response.payload.data && response.payload.data.id) {
            const saved = response.payload.data;
            updateInsights((insights, previous) => {
              // The insight can be deleted while the request is in flight.
              if (!insights[insightIndexId]) {
                return null;
              }
              const next = { ...saved };
              const counts = {};
              if (saved.id > 0) {
                counts.numberOfInsightsByManual = previous.numberOfInsightsByManual >= 0 ? previous.numberOfInsightsByManual + 1 : 0;
                next.previousCategory = saved.categoryId;
                next.previousCategoryName = saved.category;
                next.previousTheme = saved.theme;
                next.previousThemeId = saved.themeId;
                next.previousSentiment = saved.sentiment;
              }
              next.subCategory = subCategoryObj;
              insights[insightIndexId] = next;
              return counts;
            });
            props.handleSentimentCountChange('add');
          }
        }).catch(error => console.error('[bha] saveSentimentDocument failed', error));
      }
    } else {
      const insightData = currentSentence.insights[insightIndexId];
      const previousSentimentType = insightData.sentimentByNlp;
      props.sentimentUpdateContent(insightId, insightData).then((response) => {
        if (response && response.payload.data && response.payload.data.id) {
          const saved = response.payload.data;
          updateInsights((insights, previous) => {
            // The insight can be deleted while the request is in flight.
            if (!insights[insightIndexId]) {
              return null;
            }
            const next = { ...saved, subCategory: insights[insightIndexId].subCategory };
            const counts = {};
            if (saved.id > 0 && previousSentimentType) {
              counts.numberOfInsightsByNLP = previous.numberOfInsightsByNLP > 0 ? previous.numberOfInsightsByNLP - 1 : 0;
              counts.numberOfInsightsByManual = previous.numberOfInsightsByManual >= 0 ? previous.numberOfInsightsByManual + 1 : 0;
              next.sentimentByNlp = false;
            }
            if (saved.id > 0) {
              next.previousCategory = saved.categoryId;
              next.previousCategoryName = saved.category;
              next.previousTheme = saved.theme;
              next.previousThemeId = saved.themeId;
              next.previousSentiment = saved.sentiment;
            }
            if (saved.score) {
              let sentimentNew = 'neutral';
              if (saved.score > 1) {
                sentimentNew = 'positive';
              } else if (saved.score < 0) {
                sentimentNew = 'negative';
              }
              next.sentiment = sentimentNew;
            }
            insights[insightIndexId] = next;
            return counts;
          });
        }
      }).catch(error => console.error('[bha] sentimentUpdateContent failed', error));
    }
  };

  const handleDeleteSentimentModal = (index, sentencesId, insightId) => {
    if (!(insightId && insightId > 0)) {
      updateInsights((insights) => {
        delete insights[index];
        return null;
      });
    }
  };

  const handleDeleteSentimentById = (sentenceId, index) => {
    updateInsights((insights, previous) => {
      const removed = insights[index];
      const counts = {};
      if (removed && removed.sentimentByNlp) {
        counts.numberOfInsightsByNLP = previous.numberOfInsightsByNLP > 0 ? previous.numberOfInsightsByNLP - 1 : 0;
      } else {
        counts.numberOfInsightsByManual = previous.numberOfInsightsByManual > 0 ? previous.numberOfInsightsByManual - 1 : 0;
      }
      delete insights[index];
      return counts;
    });
    props.handleSentimentCountChange('delete');
  };

  const handleResetSentiment = (insightIndexId, sentencesId, insightId) => {
    updateInsights((insights) => {
      const current = insights[insightIndexId];
      if (!current) {
        return null;
      }
      const next = { ...current };
      if (insightId > 0) {
        next.sentiment = current.previousSentiment;
        next.categoryId = current.previousCategory;
        next.category = current.previousCategoryName;
        next.categoryName = current.previousCategoryName;
        if (current.previousThemeId) {
          next.theme = current.previousTheme;
          next.themeId = current.previousThemeId;
          next.themeName = current.previousTheme;
        }
      } else {
        next.sentiment = null;
        next.categoryId = null;
        next.category = null;
        next.categoryName = null;
        next.theme = null;
        next.themeId = null;
      }
      category.children.forEach((categoryItem) => {
        if (categoryItem.id === current.previousCategory) {
          next.subCategory = categoryItem.children && categoryItem.children.length > 0 ? categoryItem.children : [categoryItem];
        }
      });
      insights[insightIndexId] = next;
      return null;
    });
  };

  const handleNewSentiment = () => {
    setCurrentSentence((previous) => {
      const existing = previous.insights && previous.insights !== null ? previous.insights : [];
      return { ...previous, insights: existing.concat(getNewSentenceSentimentObj()) };
    });
  };

  const handleOpinionModal = (insightLength) => {
    const pickedOpinionItems = [];
    const pickedFeatureItems = [];
    if (currentSentence.insights && currentSentence.insights.length > 0) {
      currentSentence.insights.forEach((insight) => {
        if (insight && insight.id !== null) {
          pickedOpinionItems.push(insight.opinion);
          pickedFeatureItems.push(insight.feature);
        }
      });
    }
    // AddNewInsight appends an insight and opens this dialog in the same handler, so the
    // new insight is not in currentSentence yet. Edit a blank one at that index instead.
    const target = currentSentence.insights[insightLength] || getNewSentenceSentimentObj();
    currentSentenceInsight = target.newSentimentStatus ? target : { ...target, newSentimentStatus: false };
    setOpinionModal(true);
    setCurrentSentenceInsight(currentSentenceInsight);
    setCurrentInsightIndex(insightLength);
    setPickedOpinion(pickedOpinionItems);
    setPickedFeature(pickedFeatureItems);
    setOpenEditor(true);
  };

  const handleOpinionFeature = () => {
    if (newSentiment && newSentiment.sentenceId > 0 && currentSentence.id === newSentiment.sentenceId && passDataStatus) {
      updateInsights((insights) => {
        const next = { ...newSentiment.insight, newSentimentStatus: true, requiredField: true };
        if (newSentiment.insight.featureAltKeyword) {
          next.featureAltKeyword = newSentiment.insight.featureAltKeyword;
        }
        insights[currentInsightIndex] = next;
        return null;
      });
      setOpinionModal(false);
      setOpenEditor(false);
    }
  };

  const updateInsightsValues = (insightsObj, sentenceIdPresent, index) => {
    const newObj = [];
    newObj.insight = insightsObj;
    if (insightsObj && insightsObj.featureAltKeyword !== null) {
      newObj.insight.featureKeyword = null;
      newObj.insight.featureAltKeyword = insightsObj.featureAltKeyword;
    }
    newObj.sentenceId = sentenceIdPresent;
    newObj.index = index;
    newObj.status = insightsObj.newSentimentStatus;
    setNewSentiment(newObj);
  };

  const showHideOpinionModal = () => {
    setOpenEditor(false);
    setOpinionModal(false);
    const editing = currentSentence.insights[currentInsightIndex];
    if (currentSentence.id && currentInsightIndex && editing && !editing.requiredField) {
      patchInsight(currentInsightIndex, {
        opinion: null, feature: null, featureAltKeyword: null, featureKeyword: null
      });
    }
  };

  return (
    <div style={{ marginBottom: '10px' }}>
      <div className="sentence-card" style={{ height: '90px' }}>
        <div xs={1} md={1} className="sentence-card-left no-padding-sentence" style={{ height: '90px', paddingTop: '15px', paddingLeft: '20px' }}>
          <div className="number-circle-icon" style={{ paddingLeft: '0' }}>
            <MozartIcon width="32px" height="32px" data={sentenceIndex + 1} />
          </div>
        </div>
        <div xs={10} md={10} className="sentence-card-middle no-padding-sentence" style={{ height: '90px' }}>
          <div className="sentence-line">
            <div className="sentiment-sentence-title">
              <span className="sentence-id-text"> Sentence ID :</span>
              <span className="sentence-id">{currentSentence.id}</span>
            </div>
            <div className="sentiment-sentence">{sentenceCustomText}</div>
          </div>
        </div>
        <div xs={1} md={1} className="sentence-card-right no-padding-sentence" style={{ height: '90px' }}>
          <div className="sentiment-count" style={{ paddingTop: '14px' }}>
            <div className="nlp-sentiment-count">
              <span className="nlp-count">{currentSentence.numberOfInsightsByNLP}</span>
              <span className="nlp-text"> NLP</span>
            </div>
            <div className="nlp-sentiment-count">
              <span className="nlp-count">{currentSentence.numberOfInsightsByManual}</span>
              <span className="nlp-text"> Manual</span>
            </div>
          </div>
          <AddNewInsight
            currentSentence={currentSentence}
            handleNewSentiment={handleNewSentiment}
            handleOpinionModal={handleOpinionModal}
          />
        </div>
      </div>
      {getInsights(currentSentence.insights)}
      {opinionModal && (
        <MozartModal
          show={opinionModal}
          onClose={showHideOpinionModal}
          title="Select Opinion and feature"
          width="975px"
          contentPadding="20px"
          className="review-modal"
          submitLabel="Add"
          handleSubmit={() => { handleOpinionFeature(); }}
          id={'opinion-modal-' + currentSentence.id}
          submitButtonClassName={enableClass}
          enableCancel
        >
          <OpinionFeature
            testProp=""
            entity={entity}
            opinion={opinion}
            feature={feature}
            id="opinionModal"
            fullReview={fullReview}
            pickedOpinion={pickedOpinion}
            pickedFeature={pickedFeature}
            surveyQuestion={surveyQuestion}
            warningMessage={warningMessage}
            currentSentence={currentSentence}
            providerLocation={providerLocation}
            currentSentenceId={currentSentence.id}
            currentInsightIndex={currentInsightIndex}
            onChangeInsightsValues={updateInsightsValues}
            currentSentenceInsight={currentSentenceInsight}
          />
        </MozartModal>
      )}
    </div>
  );
}

Sentence.propTypes = {
  contentId: propTypes.number,
  sentenceIndex: propTypes.number,
  fullReview: propTypes.string,
  category: propTypes.object,
  sentence: propTypes.object,
  documentReducer: propTypes.object,
  getNewSentenceSentimentObj: propTypes.object,
  subCategory: propTypes.array,
  subCategories: propTypes.array,
  saveSentimentDocument: propTypes.func,
  sentimentUpdateContent: propTypes.func,
  handleSentimentCountChange: propTypes.func,
};

const mapStateToProps = state => ({
  documentReducer: state.documentReducer,
});

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    saveSentimentDocument, sentimentUpdateContent
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(Sentence));
